import {getAccount,} from './queries';

import {GraphQLQuery,} from '@aws-amplify/api';

import {GetAccount,} from "../types.ts";

import {showErrorNotifications,} from "../../../components/ServiceNotifications.tsx";
import {generateClient} from "aws-amplify/api";
import {consoleApiConfig} from "../config/flexinet-console-api.ts";


const client = generateClient({
                                  endpoint: consoleApiConfig.endpoint,
                                  region: consoleApiConfig.region,
                                  authMode: 'userPool'
                              });


export const fetch = async (id: string) => {
    try {
        const response = await client.graphql<GraphQLQuery<GetAccount>>({
                                                                            query: getAccount,
                                                                            variables: {id: id},
                                                                        });
        return response.data?.getAccount;
    } catch (e) {
        console.trace(e);
        showErrorNotifications(e)
    }
};

